import {
  GenerateDocumentAction,
  LabOrderAction,
  RequestPaymentToolbarAction,
  SendFollowUpAction,
  SendFormsAction,
} from './actions';
import { type ActionConfig } from './types';

// Action IDs
export const TOOLBAR_ACTION_IDS = {
  SEND_COMMUNICATION: 'send-communication',
  LAB_ORDER: 'order-labs',
  GENERATE_DOCUMENT: 'generate-document',
  REQUEST_PAYMENT: 'request-payment',
  SEND_FORMS: 'send-forms',
  SEND_FOLLOW_UP: 'send-follow-up',
} as const;

// Feature flags
export const TOOLBAR_FEATURE_FLAGS = {
  PATIENT_COMMUNICATIONS: 'patient_communications',
  LAB_ORDERS: 'lab_orders',
  STRIPE_CONNECT: 'stripe_connect',
  FORMS: 'forms',
} as const;

// Modal types (these should match the modal registry)
export const TOOLBAR_MODAL_TYPES = {
  SEND_COMMUNICATION: 'SEND_COMMUNICATION',
  LAB_ORDER: 'LAB_ORDER',
  GENERATE_DOCUMENT: 'GENERATE_DOCUMENT',
  REQUEST_PAYMENT: 'REQUEST_PAYMENT',
} as const;

// Default toolbar actions
export const DEFAULT_TOOLBAR_ACTIONS: ActionConfig[] = [
  {
    id: TOOLBAR_ACTION_IDS.SEND_FORMS,
    component: SendFormsAction,
  },
  // {
  //   id: TOOLBAR_ACTION_IDS.SEND_COMMUNICATION,
  //   component: SendCommunicationAction,
  // },
  {
    id: TOOLBAR_ACTION_IDS.LAB_ORDER,
    component: LabOrderAction,
  },
  {
    id: TOOLBAR_ACTION_IDS.GENERATE_DOCUMENT,
    component: GenerateDocumentAction,
  },
  {
    id: TOOLBAR_ACTION_IDS.SEND_FOLLOW_UP,
    component: SendFollowUpAction,
  },
  {
    id: TOOLBAR_ACTION_IDS.REQUEST_PAYMENT,
    component: RequestPaymentToolbarAction,
  },
];
